const currency = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });
const oneDecimal = new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 1 });

const toNumber = (value: unknown): number | null => {
  if (value === null || value === undefined || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};
const pad = (n: number) => String(n).padStart(2, "0");

export function formatBRL(value: number | string | null | undefined, fallback = "—"): string {
  const n = toNumber(value);
  return n === null ? fallback : currency.format(n);
}

export function formatDateBR(iso: string | null | undefined, fallback = ""): string {
  if (!iso || typeof iso !== "string") return fallback;
  const [y, m, d] = iso.slice(0, 10).split("-");
  if (!/^\d{4}$/.test(y || "") || !/^\d{2}$/.test(m || "") || !/^\d{2}$/.test(d || "")) return fallback;
  return `${d}/${m}/${y}`;
}

export function formatDateTimeBR(value: Date | string | null | undefined, fallback = ""): string {
  if (value === null || value === undefined) return fallback;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function formatPercent(fraction: number | string | null | undefined, fallback = "—"): string {
  const n = toNumber(fraction);
  return n === null ? fallback : `${oneDecimal.format(n * 100)}%`;
}
